import { filter, flow, get, keyBy, map, mapValues, reverse, sortBy } from 'lodash/fp';

const mapCategories = map(item => ({
  id: item.id,
  abbr: item.abbreviation || item.short_name,
  shortName: item.short_name || item.name,
  name: item.name
}));

function mapAndFilterCategories(categories) {
  const filteredCategories = filter('display', categories);

  if (filteredCategories.length === 0) {
    return mapCategories(categories);
  }

  return mapCategories(sortBy('order', filteredCategories));
}

const mapStats = flow(keyBy('id'), mapValues('value'));

const mapGames = flow(
  filter('played'),
  reverse,
  map(item => ({
    id: item.id,
    awayAbbr: get('away_team.abbreviation', item),
    awayId: get('away_team.id', item),
    awayName: get('away_team.name', item),
    homeAbbr: get('home_team.abbreviation', item),
    homeId: get('home_team.id', item),
    homeName: get('home_team.name', item),
    score: get('score', item),
    startTime: get('start_time', item),
    stats: mapStats(item.stats)
  }))
);

function decodePlayerCompetitionStats(data) {
  return mapValues(fn => fn(data), {
    averageScore: get('competition_player.aggregates.overall.average_score'),
    categories: flow(get('stat_types'), mapAndFilterCategories),
    competitionId: get('competition_player.competition.id'),
    competitionName: get('competition_player.competition.name'),
    entityId: get('competition_player.player.id'),
    games: flow(get('competition_player.games'), mapGames),
    highScore: get('competition_player.high_score_game.score'),
    maxScore: get('competition_player.competition.competition_type.max_onescore'),
    name: get('competition_player.player.name'),
    positionAbbr: get('competition_player.position.abbreviation'),
    positionName: get('competition_player.position.name'),
    sportId: get('competition_player.competition.competition_type.sport.id'),
    teamAbbr: get('competition_player.player_team.abbreviation'),
    teamId: get('competition_player.player_team.id'),
    teamName: get('competition_player.player_team.name'),
    news: get('competition_player.player.news')
  });
}

export default decodePlayerCompetitionStats;
